export default __webpack_public_path__ + "static/media/IMG_0838.c671fd65.jpeg";